<div class="about-item-container">
    <div class="image-container">
        <img [src]="this.imageSource" />
    </div>
    <h2 class="number-text">{{smallNumber}}</h2>
    <p class="display-body">{{text ?? 'Explain what we need to do here'}}</p>
</div>